import {
  COMPETITOR_GAP_SET_CONTEXTO,
  COMPETITOR_GAP_SET_CONTEXTO_LOADING,
  COMPETITOR_GAP_SET_CONTEXTO_ERRO,
  COMPETITOR_GAP_SET_GAPS,
  COMPETITOR_GAP_SET_LISTA_LOADING,
  COMPETITOR_GAP_SET_LISTA_ERRO,
  COMPETITOR_GAP_SET_DETALHE,
  COMPETITOR_GAP_SET_DETALHE_LOADING,
  COMPETITOR_GAP_SET_DETALHE_ERRO,
  COMPETITOR_GAP_SET_FILTRO_STATUS,
  COMPETITOR_GAP_LIMPAR_DETALHE,
  COMPETITOR_GAP_RESET
} from './competitorgapActions'

const initialState = {
  contexto: {
    projetoId: null,
    projetoNome: '',
    empresaPdcaExiste: false,
    empresaPdcaId: null,
    empresaPdcaNome: ''
  },

  gaps: [],
  detalhe: null,

  filtroStatusId: 1,

  contextoCarregado: false,
  listaCarregada: false,
  detalheCarregado: false,

  loadingContexto: false,
  loadingLista: false,
  loadingDetalhe: false,

  erroContexto: null,
  erroLista: null,
  erroDetalhe: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPETITOR_GAP_SET_CONTEXTO:
      return {
        ...state,
        contexto: payload,
        contextoCarregado: true,
        erroContexto: null
      }

    case COMPETITOR_GAP_SET_CONTEXTO_LOADING:
      return {
        ...state,
        loadingContexto: payload
      }

    case COMPETITOR_GAP_SET_CONTEXTO_ERRO:
      return {
        ...state,
        erroContexto: payload,
        contextoCarregado: false
      }

    case COMPETITOR_GAP_SET_GAPS:
      return {
        ...state,
        gaps: payload,
        listaCarregada: true,
        erroLista: null
      }

    case COMPETITOR_GAP_SET_LISTA_LOADING:
      return {
        ...state,
        loadingLista: payload
      }

    case COMPETITOR_GAP_SET_LISTA_ERRO:
      return {
        ...state,
        erroLista: payload,
        listaCarregada: false
      }

    case COMPETITOR_GAP_SET_DETALHE:
      return {
        ...state,
        detalhe: payload,
        detalheCarregado: true,
        erroDetalhe: null
      }

    case COMPETITOR_GAP_SET_DETALHE_LOADING:
      return {
        ...state,
        loadingDetalhe: payload
      }

    case COMPETITOR_GAP_SET_DETALHE_ERRO:
      return {
        ...state,
        erroDetalhe: payload,
        detalheCarregado: false
      }

    case COMPETITOR_GAP_SET_FILTRO_STATUS:
      return {
        ...state,
        filtroStatusId: payload
      }

    case COMPETITOR_GAP_LIMPAR_DETALHE:
      return {
        ...state,
        detalhe: null,
        detalheCarregado: false,
        erroDetalhe: null
      }

    case COMPETITOR_GAP_RESET:
      return initialState

    default:
      return state
  }
}